export default __webpack_public_path__ + "static/media/getStarted.42f8a9db.svg";